// libs
import React from 'react';
import moment from "moment/moment";
// components
import { Link } from 'react-router-dom';
// services
import AuthService from "../../../../../services/AuthService";
import MembersApi from '../../../../../services/portal-api/MembersApi';
import swal from 'sweetalert';

const PersonalDetails = (props) => {
    const { member, deleteAccount, handleButtonNameChange, buttonName, disableButton } = props;

    const birthdate = member.birthdate ? moment(member.birthdate).format('D MMMM YYYY') : '-';
    const address1 = member ? $.grep([member.streetAddress1, member.streetAddress2], Boolean).join(', ') : '';

    const isEditMemberEnabled = (
        !member.isPending &&
        !member.isStubRecord &&
        (member.isActiveRecord || AuthService.isAdmin()) &&
        member.firstName != 'Deleted'

    );

    const handleDelete = (member) => {
        swal({
            title: "Are you sure?",
            text: "you really want to delete?",
            icon: "warning",
            dangerMode: true,
            closeOnClickOutside: false,
            closeOnEsc: false,
            buttons: ["Cancel", "Yes"],
        })
        .then((value) => {
            if(value) {
                swal("Deleting...", {
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                });

                handleButtonNameChange();
                
                const data = {
                    firstName: 'Deleted',
                    lastName: 'Account',
                    email: '',
                    noEmail: true,
                    hiddenEmail: member.email,
                    mobile: '',
                    birthday: '',
                    noBirthday: true,
                    hiddenBirthday: member.birthdate,
                    suburb: member.suburb,
                    postcode: member.postcode,
                    countryState: member.countryState,
                    rewardsExpiryDate: '',
                    country: '',
                    deletedAt: 1,
                };
            
                MembersApi.updateMember(member.givexCustomerId, data, (response) => {
                    swal.close();
                    handleButtonNameChange();

                    if (response.json.success) {
                        swal("Account deleted", {
                            icon: "success",
                            buttons: false,
                            timer: 3000
                        }).then(() => {
                            deleteAccount(member.givexCustomerId);
                        });
                    } else {
                        swal("Something went wrong", {
                            icon: "error",
                            buttons: false,
                            timer: 3000
                        });
                    }
                });
            } 
        }); 
    }

    return (
        <div className="margin--30--bot relative">
            <h3 className="sub-title margin--10--bot">Personal Details</h3>
            <ul className="list--box list--info">
                <li>
                    <p className="list--info__label"><strong
                        className="text--caps text--color">Email</strong> <span
                            className="text--break">{member.email}</span></p>
                    <p className="list--info__label"><strong
                        className="text--caps text--color">Mobile</strong> <span
                            className="text--break">{member.mobile}</span></p>
                    <p className="list--info__label"><strong
                        className="text--caps text--color">Birthdate</strong> {birthdate}
                    </p>
                    <p className="list--info__label"><strong
                        className="text--caps text--color">Address</strong>
                        {address1}
                        {address1 !== '' && <br />}
                        {$.grep([member.suburb, member.state, member.postcode], Boolean).join(', ')}
                    </p>
                    {((isEditMemberEnabled && AuthService.can('Edit member')) || AuthService.can('edit deleted member')) &&
                        <Link to={{ 'pathname': '/members/' + member.slug + '/edit', 'state': { member: member } }}
                            className="btn btn--small btn--color btn--open" style={{ marginRight: '10px' }}>Edit
                            <img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" />
                        </Link>
                    }
                    
                    {member.firstName != 'Deleted' && AuthService.can('delete member') &&
                        <button onClick={() => handleDelete(member)} disable={disableButton} class="btn btn--small btn--color margin--10--right" style={{marginRight:'10px'}}>
                            {buttonName}
                        </button>
                    }
                    
                    {AuthService.can('View update history') &&
                        <Link to={{ 'pathname': '/members/' + member.givexCustomerId + '/viewUpdateHistory', 'state': { 'prevPath': location.pathname } }} 
                            className={isEditMemberEnabled ? "btn btn--small btn--color btn--open margin--30--top f-right" : "btn btn--small btn--color btn--open"}>View Update History 
                            <img className="icon" src="/img/icon-arrowOpen--white.svg" width="10" height="10" />
                        </Link>
                    }
                </li>
            </ul>
        </div>
    );
};

export default PersonalDetails;
